var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "groups col-4 bg-white shadow" },
          [
            _c("vue-context", {
              ref: "menusecundario",
              staticClass: "mt-5",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(child) {
                    return _c("ul", { staticClass: "context-menu-list" }, [
                      _c(
                        "li",
                        {
                          staticClass: "context-menu-item title",
                          style: {
                            "background-color":
                              _vm.themeConfig.navbarColor + " !important"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                child && child.data ? child.data.name : ""
                              ) +
                              " "
                          )
                        ]
                      ),
                      child.data && child.data.levelNode > 0
                        ? _c(
                            "li",
                            {
                              staticClass: "context-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.editSelectedEntity(child.data)
                                }
                              }
                            },
                            [_vm._v("Editar Entidad ")]
                          )
                        : _vm._e(),
                      child.data && child.data.levelNode > 0
                        ? _c(
                            "li",
                            {
                              staticClass: "context-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.editServicesEntity(child.data)
                                }
                              }
                            },
                            [_vm._v("Servicios Entidad ")]
                          )
                        : _vm._e(),
                      child.data && !child.data.levelNode
                        ? _c(
                            "li",
                            {
                              staticClass: "context-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.addNewEntityParent()
                                }
                              }
                            },
                            [_vm._v("Nueva Entidad ")]
                          )
                        : _vm._e(),
                      child.data && child.data.levelNode <= _vm.maxLevelNode
                        ? _c(
                            "li",
                            {
                              staticClass: "context-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.addNewEntity(child.data)
                                }
                              }
                            },
                            [_vm._v(" Nueva Sub-Entidad ")]
                          )
                        : _vm._e(),
                      child.data && child.data.levelNode > 0
                        ? _c(
                            "li",
                            {
                              staticClass: "context-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.usersOption(child.data)
                                }
                              }
                            },
                            [_vm._v("Usuarios de Entidad ")]
                          )
                        : _vm._e(),
                      child.data && child.data.levelNode > 0
                        ? _c(
                            "li",
                            {
                              staticClass: "context-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.deleteSelectedEntity(child.data)
                                }
                              }
                            },
                            [_vm._v("Eliminar Entidad ")]
                          )
                        : _vm._e()
                    ])
                  }
                }
              ])
            }),
            _vm.isLoadTree
              ? _c(
                  "div",
                  { staticClass: "demo-inline-spacing" },
                  [
                    _c("b-spinner", {
                      key: "primary",
                      staticClass: "mr-1",
                      attrs: { variant: "primary" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isLoadTree
              ? _c("TreeItem", {
                  staticClass: "item",
                  attrs: { "is-open-initial": true, item: _vm.treeData },
                  on: { "select-item": _vm.selectItem },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "folder-description",
                        fn: function(ref) {
                          var item = ref.item
                          var isOpen = ref.isOpen
                          return [
                            _c(
                              "div",
                              {
                                on: {
                                  contextmenu: function($event) {
                                    $event.preventDefault()
                                    return _vm.openContexIfSuperAdmin(
                                      $event,
                                      true,
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: isOpen
                                      ? "arrow-down-short"
                                      : "arrow-right-short"
                                  }
                                }),
                                _vm._v(" " + _vm._s(item.name) + " ")
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "item-description",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "ul",
                              {
                                on: {
                                  contextmenu: function($event) {
                                    $event.preventDefault()
                                    return _vm.openContexIfSuperAdmin(
                                      $event,
                                      false,
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "li",
                                  [
                                    _c("b-icon", { attrs: { icon: "dash" } }),
                                    _vm._v(" " + _vm._s(item.name) + " ")
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2013229204
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-8 bg-white shadow", attrs: { id: "user-list" } },
          [
            _c("h5", { staticClass: "text-primary" }, [_vm._v(" Usuarios ")]),
            _c("div", { staticClass: "wrap-table" }, [
              _vm.selected
                ? _c(
                    "table",
                    {
                      staticClass: "table-users stripe",
                      attrs: { "aria-hidden": "true" }
                    },
                    [
                      _c("th", [_vm._v("Nombre")]),
                      _vm._l(_vm.usersOnOption, function(user, indextr) {
                        return _c("tr", { key: indextr }, [
                          _c("td", [
                            _c("span", { staticClass: "d-flex ml-5" }, [
                              user.avatar
                                ? _c("img", {
                                    key: "onlineImg",
                                    staticClass:
                                      "rounded-full shadow-md cursor-pointer",
                                    attrs: {
                                      src: user.avatar,
                                      alt: "user-img",
                                      width: "40",
                                      height: "40"
                                    }
                                  })
                                : _vm._e(),
                              !user.avatar
                                ? _c("img", {
                                    key: "onlineImg",
                                    staticClass:
                                      "rounded-full shadow-md cursor-pointer",
                                    attrs: {
                                      src: _vm.noAvatar,
                                      alt: "user-img",
                                      width: "40",
                                      height: "40"
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "ml-3",
                                  staticStyle: { "line-height": "40px" }
                                },
                                [_vm._v(" " + _vm._s(user.name) + " ")]
                              )
                            ])
                          ]),
                          _c("td", [
                            _c(
                              "div",
                              { staticClass: "wrap-actions" },
                              [
                                _c("b-dropdown", {
                                  attrs: {
                                    variant: "link",
                                    "no-caret": "",
                                    right: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function() {
                                          return [
                                            _c("b-icon", {
                                              staticClass: "m-1",
                                              attrs: {
                                                variant: "danger",
                                                icon: "trash-fill"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteOptionUser(
                                                    user
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      })
                    ],
                    2
                  )
                : _vm._e()
            ])
          ]
        ),
        _c(
          "b-modal",
          {
            ref: "newfolder",
            attrs: {
              id: "new-folder",
              title: "Nueva Entidad",
              "hide-footer": "",
              "no-close-on-backdrop": ""
            }
          },
          [
            _c("div", { staticClass: "row mb-5" }, [
              _c("div", { staticClass: "col-md-12 mt-3" }, [
                _c("label", [_vm._v("Nombre")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newitem.name,
                      expression: "newitem.name"
                    }
                  ],
                  staticClass: "form-control",
                  domProps: { value: _vm.newitem.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.newitem, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "col-md-12 mt-3" }, [
                _c(
                  "div",
                  { staticStyle: { float: "right" } },
                  [
                    _c(
                      "vs-button",
                      {
                        staticClass: "action",
                        attrs: {
                          color: "primary",
                          type: "border",
                          icon: "save"
                        },
                        on: {
                          click: function($event) {
                            _vm.isNewParentEntity
                              ? _vm.saveNewEntityParent()
                              : _vm.saveNewEntity()
                          }
                        }
                      },
                      [_vm._v(" Guardar ")]
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        ),
        _c(
          "b-modal",
          {
            ref: "optionUsers",
            attrs: {
              size: "lg",
              "hide-footer": "",
              "no-close-on-backdrop": "",
              title: "Usuarios de la Entidad"
            }
          },
          [
            _c("users-option", {
              attrs: { usersGeneral: _vm.usersGeneral, option: _vm.selected }
            })
          ],
          1
        ),
        _c(
          "b-modal",
          {
            ref: "entity-edit",
            attrs: {
              size: "lg",
              "hide-footer": "",
              "no-close-on-backdrop": "",
              title: "Editar entidad " + _vm.selected.name
            }
          },
          [
            _c("entity-edit", {
              attrs: { entity: _vm.selected },
              on: { edited: _vm.handleOnEdit }
            })
          ],
          1
        ),
        _c(
          "b-modal",
          {
            ref: "entity-services-edit",
            attrs: {
              size: "lg",
              "hide-footer": "",
              "no-close-on-backdrop": "",
              title: "Servicios entidad " + _vm.selected.name
            }
          },
          [
            _c("entity-services-edit", {
              attrs: { entity: _vm.selected },
              on: { edited: _vm.handleOnServiceEdit }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", [
        _c("h4", { staticClass: "text-primary" }, [
          _vm._v(" Gestión de Entidades ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }